import RegisterPanel from './RegisterPanel';

export default RegisterPanel;
